export default __webpack_public_path__ + "static/banner_bg-f1e5be343cb35bae858dc81c8fc61531.webp";